var HulkappsGifting = {

    init: function () {
        hulkCustomGiftJSON = {};
        hulkCustomGiftJSON.randomID = Math.floor((Math.random() * 10000) + 1);
        hulkCustomGiftJSON.items = [];
        hulkCustomGiftJSON.selectedProductData = [];
        hulkCustomGiftJSON.slots = 0;
        hulkDefaultGiftBox = {};
        hulkSelectedGiftBoxVariant = {};
        editBoxAction = false;
        editBoxId = null;
        activeSlide = 0;

        if($('[data-customGiftBox]').length > 0){
            let giftBoxData = $('[data-customGiftBox]').html();
            giftBoxData = JSON.parse(giftBoxData);
            hulkDefaultGiftBox = giftBoxData;
            HulkappsGifting._updateGiftBoxProduct(0);
        }

        // Init functions
        HulkappsGifting.EditGiftBox();
        HulkappsGifting.addToGiftAction();
        HulkappsGifting.addGiftBoxToCart();
        HulkappsGifting.giftMessageControl();
        HulkappsGifting.removeGiftBoxFromCart();
        HulkappsGifting.EditGiftMessage();
        HulkappsGifting._quickView();

        $('[data-customgiftpreview]').owlCarousel({
            navigation:true,
            loop: false,
            singleItem:true,
            autoWidth:true,
            rewindNav: false,
            responsive: true,
            pagination : false
        });
    },

    _updateAccordion: function(){
        $('.quickviewContainer .accordion.headings').each(function() {
            if($(this).parent()[0].classList.contains('accordion-wrapper') == false){
              $(this).find('li').wrapInner('<div class="trigger"></div>');
              $(this).find('li .trigger').append('<div class="bg"></div>');
              return $(this).add($(this).next('.accordion.content')).wrapAll("<div class='accordion-wrapper'/>");
            }
        });
        $('.quickviewContainer .accordion-wrapper').each(function() {
            var accordion_content, accordion_heading;
            accordion_heading = $(this).find('.accordion.headings > li');
            accordion_content = $(this).find('.accordion.content > li');
            accordion_heading.first().addClass('active');
            accordion_content.each(function(index) {
                var content;
                content = $('<div class="content">' + $(this).html() + '</div>');
                return content.appendTo(accordion_heading.eq(index));
            });
            accordion_content.remove();
            $(this).find('.content').first().show();
            return $(this).find('.trigger').on("click", function() {
                var panels, this_panel;
                panels = $(this).closest(".accordion").find('.content');
                this_panel = $(this).closest("li").find(".content");
                panels.not(this_panel).slideUp(200);
                this_panel.slideDown(200);
                $(this).closest(".accordion").find("li").removeClass("active");
                return $(this).closest("li").addClass("active");
            });
        });
    },

    _quickView: function(){
        $('body').on('click', '[data-gitProductListing] .product--image-wrapper, [data-gitProductListing] .product--title, [data-gitProductListing] .product-price-container a', function(event){
            event.preventDefault();
            let divContainer = $(event.currentTarget).closest('.product--root');
            let proHandle = divContainer.attr('data-handle');
            if(proHandle == undefined || proHandle == null){
                return false;
            }
            $.ajax({
                type: "GET",
                url: "/products/"+proHandle+"?view=quickview",
              }).done(function(data, textStatus, jqXHR) {
                let productDiv = $(data).find('[data-quickviewPopup]');
                $('.quickviewContainer').html(productDiv);
                $('.quickView-slider').owlCarousel({
                    navigation:true,
                    loop: false,
                    rewindNav: false,
                    responsive: false,
                    items:1,
                    pagination : true
                });
                HulkappsGifting._updateAccordion();
                if (typeof Yotpo !== 'undefined') {
                    var api = new Yotpo.API(yotpo);
                    api.refreshWidgets();
                }
                $('.quickviewContainer').show();
              }).fail(function(jqXHR, textStatus) {
                return console.log('Error - Product Data Not Found. ', JSON.parse(jqXHR.responseText).description);
              });
        });
        $('body').on('click', '[data-quickviewpopup], [data-closeQuickviewpopup]', function(event){
            event.preventDefault();
            $('.quickviewContainer').html('').hide();
        });
        $('body').on('click', '.quickView-popup-modal', function(event){
            event.stopPropagation();
        });
        $('body').on('click', '[data-addtogiftfromquick]', function(event){
            event.preventDefault();
            let productId = $(event.currentTarget).attr('data-productid');
            let productForm = $('[data-gitproductlisting] form.product-form[data-productid="'+productId+'"] ');
            if(productForm){
                $(productForm).find('[data-addtogiftbox]').trigger('click');
                $('.quickviewContainer').html('').hide();
            }
        });
    },

    _updateGiftBoxProduct: function(varIndex){
        hulkSelectedGiftBoxVariant = hulkDefaultGiftBox.variants[varIndex];
        hulkCustomGiftJSON.items[0] = {
            id: hulkSelectedGiftBoxVariant.id,
            quantity: 1,
            properties: {
                giftID: hulkCustomGiftJSON.randomID,
                product_type: 'GiftBox',
            }
        }
        hulkCustomGiftJSON.selectedProductData[0] = {
            id: hulkSelectedGiftBoxVariant.id,
            title: hulkSelectedGiftBoxVariant.title,
            image: hulkSelectedGiftBoxVariant.img,
        }
    },

    _getSelectedProductsData: function(id){
        let product = null;
        $(hulkCustomGiftJSON.selectedProductData).each(function(i, data){
            if(parseInt(data.id) == id){
                product =  data;
            }
        });
        return product;
    },

    getGiftBoxVariant: function(slots){
        let varIndex = null;
        let boxFound = false;
        $(hulkDefaultGiftBox.variants).each(function(i, variant){
            if(variant.slots >= slots && boxFound == false){
                varIndex = i;
                boxFound = true;
            }
        });
        return varIndex;
    },

    getExistedIndex: function(array, attr, value) {
        // Function to get index value of object which qualifies condition
        for (var i = 0; i < array.length; i += 1) {
            let arrayValue = array[i][attr].toString()
            let selectedValue = value.toString();
            if (arrayValue === selectedValue) {
                return i;
            }
        }
        return -1;
    },

    addToGiftAction: function(){
        $('body').on('click', '[data-addtogiftbox]', function(event){
            event.preventDefault();
            const currentTarget = $(event.currentTarget);
            const closestForm = currentTarget.closest('form');
            let proID = closestForm.find('[name="id"]').val();
            let productSlots = closestForm.attr('data-slots');
            if(productSlots == undefined || productSlots == null){
                productSlots = 0;
            }
            productSlots = parseInt(productSlots);

            let itemIndexSelection = HulkappsGifting.getExistedIndex(hulkCustomGiftJSON.items, 'id', proID);
            hulkCustomGiftJSON.slots = hulkCustomGiftJSON.slots + productSlots;
            let variantIndex = HulkappsGifting.getGiftBoxVariant(hulkCustomGiftJSON.slots);
            if(variantIndex == null){
                // console.log(variantIndex);
                $('[data-boxFullPopup]').addClass('active-popup');
                hulkCustomGiftJSON.slots = hulkCustomGiftJSON.slots - productSlots;
            }else{
                let selectedProductData = {
                    id: proID,
                    image: closestForm.attr('data-img'),
                    title: closestForm.attr('data-title'),
                    price: closestForm.attr('data-price'),
                    originalPrice: closestForm.attr('data-originalprice'),
                    slots: closestForm.attr('data-slots'),
                    minBox: closestForm.attr('data-minBox'),
                };
                let selectedProduct = {
                    id: proID,
                    quantity: 1,
                    properties: {
                        product_type: 'GiftBoxItem',
                        giftID: hulkCustomGiftJSON.randomID
                    }
                };

                hulkCustomGiftJSON.items.push(selectedProduct);
                hulkCustomGiftJSON.selectedProductData.push(selectedProductData);
                activeSlide = -1;
                HulkappsGifting.reBuildGiftPreview(hulkCustomGiftJSON.items);
                $('.gifting-row .accordion li:eq(0) .trigger').trigger('click');
                setTimeout(function(){
                    $('.body--overlay').trigger('click');
                }, 2000);
            }

        });
        $('body').on('click', '[data-removeFromGiftSet]', function(event){
            event.preventDefault();
            let proID = $(event.currentTarget).attr('data-id');
            let productSlots = $(event.currentTarget).attr('data-slots');
            let itemIndexSelection = HulkappsGifting.getExistedIndex(hulkCustomGiftJSON.items, 'id', proID);
            let slideIndex = $(event.currentTarget).closest('.owl-item').index();
            if(slideIndex > -1){
                activeSlide = slideIndex;
            }

            hulkCustomGiftJSON.items.splice(itemIndexSelection, 1);
            hulkCustomGiftJSON.selectedProductData.splice(itemIndexSelection, 1);
            hulkCustomGiftJSON.slots = hulkCustomGiftJSON.slots - productSlots;
            HulkappsGifting.reBuildGiftPreview(hulkCustomGiftJSON.items);
            $('.gifting-box .accordion.headings > li:eq(0)').addClass('active');
        });
    },

    reinitSlider: function(){
        // Init sample View Slider
        $('[data-customgiftpreview]').data('owlCarousel').destroy();
        $('[data-customgiftpreview]').owlCarousel({
            navigation:true,
            loop: false,
            singleItem:true,
            autoWidth:true,
            rewindNav: false,
            responsive: true,
            pagination : false
        });
        $('[data-customgiftpreview] .owl-wrapper').trigger('owl.goTo', activeSlide);
    },

    reBuildGiftPreview: function(itemsJSON){
        let previewHTML = '';
        let finalTotal = 0;
        let changeDefaulBox = false;
        let finalIndex = $(itemsJSON).length - 1;
        let variantIndex = HulkappsGifting.getGiftBoxVariant(hulkCustomGiftJSON.slots);
        if(variantIndex == null){
            variantIndex = 0;
        }
        hulkSelectedGiftBoxVariant = hulkDefaultGiftBox.variants[variantIndex];
        let customGiftCount = 0;
        if($(itemsJSON).length > 0){
            customGiftCount = $(itemsJSON).length - 1;
        }
        $('.product--root').removeClass('giftSelected');
        $(itemsJSON).each(function(i, item){
            let itemNo = i + 1;
            let rank = itemNo % 4;
            let itemHtml = '';
            let originalPrice = null;
            let productForm = $('form[data-productid="'+item.id+'"]');
            let title,price,image,slots,minBox;
            let productData = HulkappsGifting._getSelectedProductsData(item.id);
            let emptySlots = 4 - rank;
            if(rank == 0){
                emptySlots = 0;
            }

            $(productForm).closest('.product--root').addClass('giftSelected');
            if(productData){
                originalPrice = productData.originalPrice;
            }
            if(originalPrice == null || originalPrice == undefined){
                originalPrice = 0;
            }
            originalPrice = parseInt(originalPrice);
            finalTotal = finalTotal + originalPrice;

            if(i == 0){
                item.id = hulkSelectedGiftBoxVariant.id;
                title = hulkSelectedGiftBoxVariant.title;
                image = hulkSelectedGiftBoxVariant.image;
                price = 'FREE';
                slots = 0;
            }else{
                title = productData.title;
                image = productData.image;
                price = productData.price;
                slots = productData.slots;
                minBox = productData.minBox;
                if(slots == undefined || slots == null){
                    slots = 0;
                }
            }

            if(minBox == 'Medium' && hulkSelectedGiftBoxVariant.title == 'Small'){
                hulkSelectedGiftBoxVariant = hulkDefaultGiftBox.variants[1];
                changeDefaulBox = true;
            }else if(minBox == 'Large' && (hulkSelectedGiftBoxVariant.title == 'Medium' || hulkSelectedGiftBoxVariant.title == 'Small')){
                hulkSelectedGiftBoxVariant = hulkDefaultGiftBox.variants[2];
                changeDefaulBox = true;
            }

            if(rank == 1){
                itemHtml += '<div class="gift-slider__cell"><div class="row">';
            }
            itemHtml += '<div class="left columns large-6" data-giftProduct data-id="'+item.id+'"><div class="card-gift-product"><div class="gift-product-img">';
            itemHtml += '<img src="'+image+'" alt="'+title+'"/>';
            itemHtml += '<div class="gift-details text-center">';
            if(i >= 1){
                itemHtml += '<a href="#" class="close-icon" data-removeFromGiftSet data-slots="'+slots+'" data-id="'+item.id+'"><svg class="fw--icon fw--icon--cross"> <use xlink:href="#fw--icon--cross"></use> </svg></a>';
            } 
            itemHtml += '<p class="gift-price">'+price+'</p><p class="product-title">'+title+'</p></div>';
            itemHtml += '</div></div></div>';

            if(finalIndex == i && emptySlots > 0){
                let emptySlotsHTML = '';
                for(i=0; i<emptySlots; i++){
                    emptySlotsHTML +=  '<div class="left columns large-6"><div class="card-gift-product"><div class="gift-product-img empty-product"><img src="https://cdn.shopify.com/s/files/1/0052/0041/2758/files/add-product.svg?v=1599112163" alt="empty slide" /></div></div></div>';
                }
                itemHtml += emptySlotsHTML;
            }
            if(rank == 0 || finalIndex == i){
                itemHtml += '</div></div>';
            }
            previewHTML += itemHtml;
        });

        finalTotal = Shopify.formatMoney(finalTotal, shop_default_money_format);
        $('[data-customGiftPreview]').html(previewHTML);
        $('[data-customGiftCount]').html(customGiftCount);
        $('[data-customGiftTotal]').html(finalTotal);
        $('[data-customGiftSlot').html(hulkCustomGiftJSON.slots);

        if(activeSlide < 0){
            activeSlide = $('[data-customGiftPreview]').find('.gift-slider__cell').length - 1;
        }
        if(changeDefaulBox == true){
            hulkCustomGiftJSON.items[0].id = hulkSelectedGiftBoxVariant.id;
            $('[data-giftproduct]').eq(0).find('.gift-product-img img').attr('src', hulkSelectedGiftBoxVariant.image);
            $('[data-giftproduct]').eq(0).find('.gift-product-img img').attr('alt', hulkSelectedGiftBoxVariant.title);
            $('[data-giftproduct]').eq(0).find('.product-title').html(hulkSelectedGiftBoxVariant.title);
        }
        HulkappsGifting.reinitSlider();
        if($(window).width() <= 990){
            $('.body--overlay').addClass('open');
        }
        /*if(hulkCustomGiftJSON.items.length <= 1){
            $('[data-giftproduct]').hide();
            $('[data-customGiftCount]').html(0);
            let defaultSlider = '<div class="gift-slider__cell"><div class="row">';
            for(i=0; i<=3; i++){
                defaultSlider +=  '<div class="left columns large-6"><div class="card-gift-product"><div class="gift-product-img empty-product"><img src="https://cdn.shopify.com/s/files/1/0052/0041/2758/files/add-product.svg?v=1599112163" alt="empty slide" /></div></div></div>';
            }
            defaultSlider += '</div></div>';
            $('[data-customGiftPreview]').html(defaultSlider);
            HulkappsGifting.reinitSlider();
        }*/
    },

    addGiftBoxToCart: function(){
        $('[data-addCustomGift]').on('click', function(event){
            event.preventDefault();
            let currentButton = $(event.currentTarget);
            if(editBoxAction = true && editBoxId != null){
                if ($('[data-for="personalize-msg"]') && $('[data-for="personalize-msg"]').closest('li').attr('data-opened') == 'false'){
                    $('[data-for="personalize-msg"]').trigger('click');
                    $('[data-for="personalize-msg"]').closest('li').attr('data-opened', 'true');
                    return false;
                }
                $(this).attr('disabled', 'disabled');
                HulkappsGifting.removeGiftFromCartAction(editBoxId, function(success, error) {
                    if(success){
                        HulkappsGifting.addGiftBoxToCartAction(currentButton);
                    }else{
                        alert('Something Went Wrong! Try again later.');
                        $(this).removeAttr('disabled');
                    }
                });
            }else{
                HulkappsGifting.addGiftBoxToCartAction(currentButton);
            }
        });
    },

    _updateDuplicateKeys: function(itemArray){
        let finalArray = JSON.parse(JSON.stringify(itemArray));
        let duplicatedIndex = [];
        $(itemArray).each(function(index, item){
            let itemCount = 0;
            let productId = item.id;
            let found = false;
            $(hulkCustomGiftJSON.items).each(function(i, product){
                if(productId == product.id){
                    itemCount += product.quantity;
                    if(found == true && duplicatedIndex.includes(i) == false){
                        duplicatedIndex.push(i);
                    }
                    found = true;
                }
            });
            finalArray[index].quantity = itemCount;
        });

        let reduceCount = 0;
        $(duplicatedIndex).each(function(i){
            let finalIndex = duplicatedIndex[i] - reduceCount;
            finalArray.splice(finalIndex, 1);
            reduceCount += 1;
        })

        return finalArray;
    },

    addGiftBoxToCartAction: function(currentButton){
        let finalAddItems = HulkappsGifting._updateDuplicateKeys(hulkCustomGiftJSON.items);;
        let addAction = currentButton.attr('data-action');
        let GiftmessageFor = $('[data-forProp]').val();
        let GiftmessageFrom = $('[data-fromProp]').val();
        let Giftmessage = $('[data-messageProp]').val();
        let buttonText = $(currentButton).html();

        if(GiftmessageFor != '' && GiftmessageFor != undefined){
            finalAddItems[0].properties['Gift_For'] = GiftmessageFor;
        }
        if(GiftmessageFrom != '' && GiftmessageFor != undefined){
            finalAddItems[0].properties['Gift_From'] = GiftmessageFrom;
        }
        if(Giftmessage != '' && GiftmessageFor != undefined){
            finalAddItems[0].properties['Gift_Message'] = Giftmessage;
        }

        if(finalAddItems.length <= 1){
            $('[data-boxEmptyPopup]').addClass('active-popup');
            $(currentButton).removeAttr('disabled');
            return;
        }

        if($('[data-for="personalize-msg"]') && $('[data-for="personalize-msg"]').closest('li').attr('data-opened') == 'false'){
            $('[data-for="personalize-msg"]').trigger('click');
            $('[data-for="personalize-msg"]').closest('li').attr('data-opened', 'true');
            $(currentButton).removeAttr('disabled');
            return false;
        }

        $.ajax({
            type: "POST",
            url: "/cart/add.js",
            dataType: "json",
            beforeSend: function(){
                $(currentButton).html('Adding Gift...');
                $(currentButton).addClass('disabled');
            },
            data: { items: finalAddItems }
        }).done(function(data, textStatus, jqXHR) {
            if(addAction == 'redirect'){
                location.href = '/cart';
            }else{
                theme.partials.Cart.updateTotals();
                theme.partials.Cart.cartGWP();
                setTimeout(function(){
                    theme.partials.Cart.updateAllHtml(function() {});
                }, 1500);
                $(currentButton).html(buttonText); 
                $(currentButton).removeClass('disabled');
                $(currentButton).removeAttr('disabled');
                $('[data-boxfullpopup]').removeClass('active-popup');
                HulkappsGifting.resetGiftBox();
                $("html, body").animate({ scrollTop: 100 }, "slow");
            }
        }).fail(function(jqXHR, textStatus) {
            console.log('Error - ajax update quantity', JSON.parse(jqXHR.responseText).description);
        });
    },

    removeGiftBoxFromCart: function(){
        $('body').on('click', '[data-removeGiftBox]', function(event){
            event.preventDefault();
            const currentTarget = $(event.currentTarget);
            let giftID = currentTarget.attr('data-giftId');
            HulkappsGifting.removeGiftFromCartAction(giftID, function(success, error) {
                if(success){
                    theme.partials.Cart.updateTotals();
                    theme.partials.Cart.cartGWP();
                    setTimeout(function(){
                        theme.partials.Cart.updateAllHtml(function() {});
                    }, 1500);
                }else{
                    alert('Something Went Wrong! Try again later.');
                }
            });
        });
    },

    removeGiftFromCartAction: function(giftID, callback){
        let QtyArray = [];
        $('.cart--root:eq(0) [data-cartitem]').each(function(i, ele){
            if($(ele).attr('data-giftItem') == 'true' && $(ele).attr('data-identifier') == giftID){
                QtyArray.push(0);
            }else{
                let Qty = parseInt($(ele).attr('data-qty'));
                QtyArray.push(Qty);
            }
        });
        $.ajax({
            type: "POST",
            url: "/cart/update.js",
            dataType: "json",
            data:  {updates: QtyArray}
        }).done(function(data, textStatus, jqXHR) {
            return callback(true);
        }).fail(function(jqXHR, textStatus) {
            console.log('Error - ajax update quantity', JSON.parse(jqXHR.responseText).description);
            return callback(false, JSON.parse(jqXHR.responseText).description);
        });
    },

    EditGiftMessage: function(){
        $('body').on('click', '[data-giftMessageBlock]', function(event){
            let messageFor = $(event.currentTarget).attr('data-for');
            let message = $(event.currentTarget).attr('data-message');
            let messageFrom = $(event.currentTarget).attr('data-from');
            $('[data-EditGiftMessage]').attr('data-key', $(event.currentTarget).attr('data-itemIndex'));
            $('[data-EditGiftMessage]').attr('data-giftID', $(event.currentTarget).attr('data-giftID'));
            $('[data-EditGiftMessage]').addClass('active-popup');
            $('[data-forPropEditBox]').val(messageFor);
            $('[data-messagePropEditBox]').val(message);
            $('[data-fromPropEditBox]').val(messageFrom);
            $('[data-giftmessage]').trigger("change");
        });
        $('[data-updateGiftMessage]').on('click', function(event){
            let currentTarget = $(event.currentTarget);
            currentTarget.addClass('disabled');
            let key = $('[data-editgiftmessage]').attr('data-key');
            let giftMessageProperties = {
                "product_type": "GiftBox",
                "giftID": $('[data-editgiftmessage]').attr('data-giftID')
            };
            if($('[data-forPropEditBox]').val() && $('[data-forPropEditBox]').val().length > 0){
                giftMessageProperties.Gift_For = $('[data-forPropEditBox]').val();
            }
            if($('[data-messagePropEditBox]').val() && $('[data-messagePropEditBox]').val().length > 0){
                giftMessageProperties.Gift_Message = $('[data-messagePropEditBox]').val();
            }
            if($('[data-fromPropEditBox]').val() && $('[data-fromPropEditBox]').val().length > 0){
                giftMessageProperties.Gift_From = $('[data-fromPropEditBox]').val();
            }
            let item = {
                line: key,
                quantity: 1,
                properties: giftMessageProperties,
            }
            $.ajax({
                type: "POST",
                url: "/cart/change.js",
                dataType: "json",
                data: item
            }).done(function(data, textStatus, jqXHR) {
                theme.partials.Cart.updateTotals();
                theme.partials.Cart.cartGWP();
                setTimeout(function(){
                    $('[data-EditGiftMessage]').removeAttr('data-key');
                    $('[data-EditGiftMessage]').removeAttr('data-total');
                    $('[data-EditGiftMessage]').removeAttr('data-giftID');
                    $('[data-EditGiftMessage]').removeClass('active-popup');
                    currentTarget.removeClass('disabled');
                    theme.partials.Cart.updateAllHtml(function() {});
                }, 1500);
            }).fail(function(jqXHR, textStatus) {
                console.log('Error - ajax update quantity', JSON.parse(jqXHR.responseText).description);
            });
        });
    },

    EditGiftBox: function(){
        const windowUrl = window.location.href;
        if(windowUrl.indexOf('edit_gift') < 0){
            return false;
        }
        const querystring = windowUrl.split('?')[1];
        if(querystring == undefined || querystring == null){
            return false;
        }
        const parameters = querystring.split('&');
        let editIndex = parameters[0];
        if(editIndex != undefined && editIndex != null ){
            editIndex = editIndex.replace('edit_gift=', '');
            editIndex = parseInt(editIndex) - 1;
        }
        $.ajax({
            type: "GET",
            url: "/cart?view=extra.json",
        }).done(function(data, textStatus, jqXHR) {
            let response = data;
            let cartItems = [];
            if(response!= null && response != undefined){
                response = JSON.parse(response);
                cartItems = response.items;
            }

            const GiftBoxItem = cartItems[editIndex];
            if(GiftBoxItem == undefined){
                return false;
            }

            let itemType = GiftBoxItem.properties.product_type;
            let giftID = GiftBoxItem.properties.giftID;
            let Gift_For = GiftBoxItem.properties.Gift_For;
            let Gift_Message = GiftBoxItem.properties.Gift_Message;
            let Gift_From = GiftBoxItem.properties.Gift_From;

            editBoxAction = true;
            editBoxId = giftID;

            if(itemType == 'GiftBox' && giftID != undefined){
                let giftBoxItems = [];
                $(cartItems).each(function(i, item){
                    if(item.properties && item.properties.giftID == giftID){
                        giftBoxItems.push(item);
                    }
                });
                HulkappsGifting.setEditGiftBoxItem(GiftBoxItem, giftBoxItems, Gift_For, Gift_Message, Gift_From);
            }
        }).fail(function(jqXHR, textStatus) {
            console.log('Error - ajax updating totals', JSON.parse(jqXHR.responseText).description);
        });
    },

    setEditGiftBoxItem: function(GiftBoxItem, Items, Gift_For, Gift_Message, Gift_From){
        hulkCustomGiftJSON.randomID = Math.floor((Math.random() * 10000) + 1);
        hulkCustomGiftJSON.slots = 0;
        let giftBoxIndex = null;
        $(hulkDefaultGiftBox.variants).each(function(i, variant){
            if(variant.id == GiftBoxItem.id){
                giftBoxIndex = i;
            }
        });
        hulkSelectedGiftBoxVariant = hulkDefaultGiftBox.variants[giftBoxIndex];
        hulkCustomGiftJSON.items[0] = {
            id: hulkSelectedGiftBoxVariant.id,
            quantity: 1,
            properties: {
                giftID: hulkCustomGiftJSON.randomID,
                product_type: 'GiftBox',
                Gift_For: Gift_For,
                Gift_Message: Gift_Message,
                Gift_From: Gift_From
            }
        }
        hulkCustomGiftJSON.selectedProductData[0] = {
            id: hulkSelectedGiftBoxVariant.id,
            title: hulkSelectedGiftBoxVariant.title,
            image: hulkSelectedGiftBoxVariant.img,
        }

        Items = Items.reverse();
        $(Items).each(function(index, item){
            if(item.properties.product_type != 'GiftBox'){
                let itemQty = item.quantity;
                for(i=1; i<=itemQty; i++){
                    hulkCustomGiftJSON.slots = hulkCustomGiftJSON.slots + parseInt(item.Slots);
                    let addItem = {
                        id: item.id,
                        quantity: 1,
                        properties: {
                            giftID: hulkCustomGiftJSON.randomID,
                            product_type: "GiftBoxItem",
                        }
                    }
                    let productDataItem = {
                        id: item.id,
                        image: item.image,
                        minBox: item.minBox,
                        originalPrice: item.original_price,
                        price: item.price,
                        slots: item.Slots,
                        title: item.title
                    }
                    hulkCustomGiftJSON.items.push(addItem);
                    hulkCustomGiftJSON.selectedProductData.push(productDataItem);
                }
            }
        });
        HulkappsGifting.reBuildGiftPreview(hulkCustomGiftJSON.items);

        $('[data-forprop]').val(Gift_For);
        $('[data-messageprop]').val(Gift_Message);
        $('[data-fromprop]').val(Gift_From);
        $('[data-giftmessage]').trigger("change");
    },

    resetGiftBox: function(){
        hulkCustomGiftJSON.randomID = Math.floor((Math.random() * 10000) + 1);
        hulkCustomGiftJSON.items = [];
        hulkCustomGiftJSON.selectedProductData = [];
        hulkCustomGiftJSON.slots = 0;
        HulkappsGifting._updateGiftBoxProduct(0);
        $('[data-addtogiftbox] .text').html('Add to Gift Box');
        $('[data-addtogiftbox]').attr('data-addstatus', false);
        HulkappsGifting.reBuildGiftPreview(hulkCustomGiftJSON.items);
    },

    giftMessageControl: function(){
        $('[data-giftMessage]').on('change keyup', function(event){
            let currentInput = $(event.currentTarget);
            let limit = parseInt(currentInput.attr('data-limit'));
            let lengthShowEle = currentInput.attr('data-noEle');
            const text = currentInput.val();
            const value = currentInput.val().length;
            let remainingCharacter = limit - value;

            $('['+lengthShowEle+']').html(remainingCharacter);
            if(value > limit){
                currentInput.val(text.substring(0,limit));
            }
            if(remainingCharacter == 0){
                $(currentInput).addClass('error');
            }else{
                $(currentInput).removeClass('error');
            }
        });
    },

}

document.addEventListener("DOMContentLoaded", function(event) {
    HulkappsGifting.init();

    $('.body--overlay').on('click', function(){
        $('.gifting-row .accordion li').removeClass('active');
        if($(window).width()<= 990){
          $('.gifting-row .accordion li .content').slideUp(200);
        }
        $('.body--overlay').removeClass('open');
    });

    $('[data-boxfullpopup] .gifting-popup-modal, .gifting-popup-content').click(function(event) {
        event.stopPropagation();
    });

    $('.readMore').on('click', function(){
        $('.readMoreText').addClass('activeMore');
        $('.readLessText').addClass('activeLess');
    });
    $('.readLess').on('click', function(){
        $('.readMoreText').removeClass('activeMore');
        $('.readLessText').removeClass('activeLess');
    });

    $('[data-boxFullPopup], [data-boxEmptyPopup], [data-closeboxfullpopup]').on('click', function(event){
        event.preventDefault();
        $('[data-boxFullPopup]').removeClass('active-popup');
        $('[data-boxEmptyPopup]').removeClass('active-popup');
    });
    $('[data-closeboxfullpopup]').on('click', function(event){
        event.stopPropagation();
        event.preventDefault();
        $('[data-editgiftmessage]').removeClass('active-popup');
        $('[data-boxFullPopup]').removeClass('active-popup');
        $('[data-boxEmptypopup]').removeClass('active-popup');
    });

    setTimeout(function(){
        $('.gifting-row .accordion li:eq(0) .trigger').click();
    }, 1000);
    setTimeout(function(){
        $('.gifting-row .accordion li:eq(0) .trigger').click();
    }, 3000);
});

